/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery("#testimonials").owlCarousel({
		loop:false,
		dots:true,
		nav:false,
		margin:30,
		autoplay:true,
		autoplayTimeout:10000,
		responsive:{
			0:{
				items:1
			},
			450:{
				items:1
			},
			768:{
				items:2
			},
			1025:{
				items:3
			}
		}
	});

	if(jQuery('#popupAnnouncement').length)
	{
		var popup = new Foundation.Reveal(jQuery('#popupAnnouncement'));
			jQuery('#popupAnnouncement .close-button').click(function(){
			popup.close();
		});

		if(!getCookie("popupAnnouncement"))
		{
			popup.open();
			setCookie("popupAnnouncement", 1, 1);
		}
	}

	
	//Ajax filter
	jQuery('#apply-filters').submit(function(e){
		// e.preventDefault();
		var selectedLocation = jQuery('select#location').children("option:selected").val();
		var newURL = [location.protocol, '//', location.host, location.pathname].join('');
		var param = jQuery(this).find("[name!=action]").serialize();
		if(selectedLocation != '')
		{
			newURL = newURL + '?' + param;
		}
		if (history.pushState)
		{
			window.history.pushState({path:newURL},'',newURL);
		}
		applyFilters(jQuery('#apply-filters'));
		return false;
	}).submit();

	// Navigate to Jobs Showcase if location parameter is defined
	if(typeof(getUrlParameter('location')) !== "undefined")
	{
		if(jQuery('#career-section_3').length > 0)
		{
			jQuery('html, body').animate({
				scrollTop: jQuery("#career-section_3").offset().top
			}, 1000);
		}
	}
	
});

function setCookie(cname, cvalue, exdays)
{
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname)
{
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function applyFilters(filter)
{
	//var action = (filter.find('[name="action"]').val()) ? filter.find('[name="action"]').val() : 'job_filters';
	jQuery.ajax({
		url:filter.attr('action'),
		data:filter.serialize(), // form data
		type:filter.attr('method'), // POST
		beforeSend:function(xhr){
			jQuery('#loading-results').show();
			jQuery('#no-results').hide();
			jQuery('#jobs-showcase').hide();
		},
		success:function(data){
			jQuery('#loading-results').hide();
			if(data)
			{
				jQuery('#jobs-showcase').html(data); // insert data
				Foundation.reInit(['accordion']);
				jQuery('#jobs-showcase').show();
			}
			else
			{
				jQuery('#no-results').show();
			}
		}
	});
}
